import React, { useState } from 'react'
import logo from "../../Assets/images/q-nexus.png";
import loginArt from "../../Assets/images/login-bg.png";
import { loadingFalse, loadingTrue } from "../../Reducer/loaderSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Handler from "../../Helpers/Handler";
import { Link } from "react-router-dom";

const Signup = () => {
    const [fun, setF] = useState({ name: "", email: "", mobile: "" });
    const d = useDispatch();

    const submit = async () => {
        if (!fun.name || !fun.email || !fun.mobile) {
            toast.error("All fields are required");
            return;
        }
        d(loadingTrue());
        const r = await Handler({ method: "post", url: "/auth/register.php", data: fun });
        if (r?.success) {
            toast.success("Registration Successful! Check your email for the activation link.");
            setF({ name: "", email: "", mobile: "" });
        }
        else toast.error(r?.message || "Signup failed");
        d(loadingFalse());
    };

    return (
        <div className="login-page">
            <div className="login-header d-none d-md-flex">
                <img src={logo} alt="Qnexus" className="login-logo" />
            </div>
            <div className="login-center">
                <div className="login-card card">
                    <img src={logo} alt="Qnexus" className="login-logo d-block d-md-none" />
                    <h2 className="login-title text-center">Sign Up</h2>
                    <h2 className="login-description text-center">Create your Qnexus account</h2>

                    <div className="form-group mb-3">
                        <label>Name *</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter your name"
                            value={fun?.name}
                            onChange={e => setF({ ...fun, name: e.target.value })}
                        />
                    </div>

                    <div className="form-group mb-3">
                        <label>Email address *</label>
                        <input
                            type="email"
                            className="form-control"
                            placeholder="Enter email"
                            value={fun?.email}
                            onChange={e => setF({ ...fun, email: e.target.value })}
                        />
                    </div>

                    <div className="form-group mb-4">
                        <label>Mobile Number *</label>
                        <input
                            type="tel"
                            maxLength={10}
                            className="form-control"
                            placeholder="Enter mobile number"
                            value={fun?.mobile}
                            onChange={e => setF({ ...fun, mobile: e.target.value })}
                        />
                    </div>

                    <button className="btn login-btn w-100" onClick={submit}>
                        Sign Up
                    </button>

                    <div className="text-center mt-4">
                        <span className="forgot-link cursor-pointer">
                            Already have an account? <Link to={'/login'}>Login</Link>
                        </span>
                    </div>
                </div>
            </div>
            <div className="login-art-wrap d-none d-lg-block">
                <img src={loginArt} alt="illustration" />
            </div>
        </div>
    );
};

export default Signup;